<template>
    <select-label
        v-model="device"
        :disabled="isDisabled"
        :editable="isEditable"
        :items="deviceType"
        :append-icon="isDisabled ? '' : '$vuetify.icons.dropdown'"
        :rules="rules"
        item-text="text"
        item-value="value"
    />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AppContext } from '../../store/context';
const DeviceType = AppContext.DeviceType;
import SelectLabel from './SelectLabel.vue';

@Component({
    name: 'SelectorDeviceType',
    components: {
        SelectLabel,
    },
})
export default class SelectorDeviceType extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: () => [] }) readonly rules: Array<any>;
    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.device = val;
    }
    @Watch('device')
    onDeviceChanged(newMode: string): void {
        this.$emit('input', newMode);
    }

    deviceType = [];
    device = '';

    created() {
        this.deviceType = DeviceType.map(kv => {
            (kv as any).text = (this as any).$t(kv.text_key);
            return kv;
        });
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get isEditable(): boolean {
        return this.editable;
    }
}
</script>
